export default {
  common: {
    close: '關閉',
    unlocked: '已解鎖',
    confirm: '確定',
    cancel: '取消',
    all: '全部',
    locked: '未解鎖',
    clickToSelect: '點擊'
  },

  game: {
    stats: {
      total: '總計',
      combo: '連擊',
      record: '紀錄',
      days: '天數'
    },
    currentType: '當前類型',
    inUse: '使用中',
    autoTap: '自動敲擊',
    on: '開啟',
    off: '關閉',
    clickToChangeType: '點擊切換祈福類型',
    clickToChangeFish: '點擊切換木魚',
    selectType: '選擇祈福類型',
    selectTypeDesc: '選擇不同類型獲得不同祝福效果',
    typeTips: '類型小提示',
    typeTip1: '不同類型有不同的粒子特效',
    typeTip2: '切換類型不會影響連擊和統計',
    typeTip3: '各類型的敲擊數會分別計算'
  },

  brand: {
    tagline: '一聲木魚一念心',
    company: 'Homy Tech Limited'
  },

  types: {
    merit: {
      name: '功德',
      description: '累積功德,淨化心靈'
    },
    love: {
      name: '愛情',
      description: '祈求良緣,增進感情'
    },
    wealth: {
      name: '財富',
      description: '招財進寶,財源廣進'
    },
    health: {
      name: '健康',
      description: '身心健康,延年益壽'
    }
  },

  typeStats: {
    title: '敲打統計',
    subtitle: '查看各類型的敲擊次數統計',
    totalTaps: '總敲擊次數',
    allTypes: '所有類型累計',
    times: '次',
    description: '類型累計',
    tips: {
      title: '統計小提示',
      tip1: '切換不同類型可以體驗不同的祈福效果',
      tip2: '平衡各類型的敲擊可以解鎖特殊成就',
      tip3: '每種類型都有專屬的粒子特效和能量'
    }
  },

  achievements: {
    title: '修行成就',
    subtitle: '記錄您的修行歷程',
    progress: '解鎖進度',
    filterByCategory: '按類別篩選',
    unlocksFish: '解鎖特殊木魚',
    noResults: '沒有符合的成就',
    allAchievements: '全部成就',
    unlockedAchievements: '已解鎖',
    lockedAchievements: '未解鎖',
    categories: {
      all: '全部',
      tap: '敲擊',
      combo: '連擊',
      speed: '速度',
      type: '類型',
      auto: '自動',
      special: '特殊'
    },
    rarity: {
      common: '普通',
      uncommon: '非凡',
      rare: '稀有',
      epic: '史詩',
      legendary: '傳說',
      mythic: '神話'
    },
    tips: {
      title: '成就小提示',
      tip1: '持續敲擊可以解鎖更多成就',
      tip2: '嘗試不同的敲擊方式發現隱藏成就',
      tip3: '某些成就會解鎖特殊木魚',
      tip4: '成就進度會自動保存'
    }
  },

  achievementsList: {
    first_tap: {
      title: '初入佛門',
      description: '第一次敲擊木魚'
    },
    tap_100: {
      title: '誠心正意',
      description: '累計敲擊100次'
    },
    tap_500: {
      title: '勤修不輟',
      description: '累計敲擊500次'
    },
    tap_1000: {
      title: '持之以恆',
      description: '累計敲擊1,000次'
    },
    tap_5000: {
      title: '功德圓滿',
      description: '累計敲擊5,000次'
    },
    tap_10000: {
      title: '萬法歸一',
      description: '累計敲擊10,000次'
    },
    tap_50000: {
      title: '修行大師',
      description: '累計敲擊50,000次'
    },
    tap_100000: {
      title: '不朽傳說',
      description: '累計敲擊100,000次'
    },
    combo_10: {
      title: '初窺門徑',
      description: '達成10次連擊'
    },
    combo_25: {
      title: '漸入佳境',
      description: '達成25次連擊'
    },
    combo_50: {
      title: '心無旁騖',
      description: '達成50次連擊'
    },
    combo_100: {
      title: '專注一致',
      description: '達成100次連擊'
    },
    combo_200: {
      title: '天人合一',
      description: '達成200次連擊'
    },
    combo_500: {
      title: '超凡入聖',
      description: '達成500次連擊'
    },
    combo_1000: {
      title: '永恆之擊',
      description: '達成1,000次連擊'
    },
    speed_5: {
      title: '迅捷之手',
      description: '在0.5秒內連續敲擊'
    },
    speed_3: {
      title: '快手如風',
      description: '在0.2秒內連續敲擊'
    },
    speed_1: {
      title: '閃電反射',
      description: '在0.1秒內連續敲擊'
    },
    perfect_rhythm: {
      title: '完美節奏',
      description: '連續10次保持1至2秒的完美間隔'
    },
    rhythm_master: {
      title: '節奏大師',
      description: '連續30次保持1至2秒的完美間隔'
    },
    type_master: {
      title: '類型大師',
      description: '四種祈福類型各敲擊50次'
    },
    merit_devotee: {
      title: '功德虔誠者',
      description: '功德模式累計500次'
    },
    love_seeker: {
      title: '愛情追尋者',
      description: '愛情模式累計500次'
    },
    wealth_collector: {
      title: '財富收集者',
      description: '財富模式累計500次'
    },
    health_guardian: {
      title: '健康守護者',
      description: '健康模式累計500次'
    },
    buddha: {
      title: '佛光普照',
      description: '功德模式累計1,000次'
    },
    love_master: {
      title: '愛情大師',
      description: '愛情模式累計1,000次'
    },
    wealth_tycoon: {
      title: '財富大亨',
      description: '財富模式累計1,000次'
    },
    health_sage: {
      title: '健康聖者',
      description: '健康模式累計1,000次'
    },
    merit_legend: {
      title: '功德傳說',
      description: '功德模式累計2,000次'
    },
    love_legend: {
      title: '愛情傳說',
      description: '愛情模式累計2,000次'
    },
    wealth_legend: {
      title: '財富傳說',
      description: '財富模式累計2,000次'
    },
    health_legend: {
      title: '健康傳說',
      description: '健康模式累計2,000次'
    },
    balanced_monk: {
      title: '平衡修行者',
      description: '四種類型各達到100次'
    },
    ultimate_devotion: {
      title: '至高奉獻',
      description: '四種類型各達到500次'
    },
    auto_beginner: {
      title: '自動化初探',
      description: '開啟自動敲擊功能'
    },
    auto_100: {
      title: '機械助手',
      description: '自動敲擊累計100次'
    },
    auto_1000: {
      title: '自動化大師',
      description: '自動敲擊累計1,000次'
    },
    auto_5000: {
      title: '機械禪師',
      description: '自動敲擊累計5,000次'
    },
    auto_lover: {
      title: '自動化愛好者',
      description: '開啟自動敲擊10次'
    },
    lazy_master: {
      title: '放置大師',
      description: '自動敲擊累計10,000次'
    },
    night_owl: {
      title: '夜貓子',
      description: '在凌晨0至6點敲擊50次'
    },
    early_bird: {
      title: '早起鳥',
      description: '在早晨6至9點敲擊50次'
    },
    midnight_devotion: {
      title: '午夜虔誠',
      description: '在凌晨0至6點敲擊200次'
    },
    morning_blessing: {
      title: '晨曦祝福',
      description: '在早晨6至9點敲擊200次'
    },
    session_100: {
      title: '單次百擊',
      description: '單次會話敲擊100次'
    },
    session_500: {
      title: '單次狂熱',
      description: '單次會話敲擊500次'
    },
    session_1000: {
      title: '單次千擊',
      description: '單次會話敲擊1,000次'
    },
    marathon: {
      title: '馬拉松修行',
      description: '單次會話敲擊2,000次'
    },
    steady_hand: {
      title: '穩定之手',
      description: '連續20次敲擊間隔都在0.8至2秒之間'
    },
    metronome: {
      title: '節拍器',
      description: '連續10次敲擊間隔相差不超過0.1秒'
    },
    cat_lover: {
      title: '貓咪之友',
      description: '累計敲擊2,000次'
    },
    rainbow_master: {
      title: '七彩祥雲',
      description: '解鎖5種不同木魚'
    },
    cosmic_collector: {
      title: '宇宙真理',
      description: '達到10,000次敲擊'
    },
    fish_collector: {
      title: '木魚收藏家',
      description: '解鎖所有特殊木魚'
    },
    achievement_hunter: {
      title: '成就獵人',
      description: '解鎖20個成就'
    },
    completionist: {
      title: '完美主義者',
      description: '解鎖40個成就'
    },
    true_master: {
      title: '真正的大師',
      description: '解鎖所有成就'
    }
  },

  specialFish: {
    title: '特殊木魚',
    subtitle: '收集並使用特殊木魚',
    progress: '收集進度',
    unlockCondition: '解鎖條件',
    howToUnlock: '如何解鎖',
    description: '完成特定成就可解鎖特殊木魚,每種木魚都有獨特外觀',
    clickToSelect: '點擊選擇木魚',
    clickToSelectDesc: '點擊下方任一已解鎖的木魚卡片,即可切換使用該木魚。選中的木魚會顯示 ✓ 標記。',
    types: {
      normal: {
        name: '普通木魚',
        description: '基本款木魚,敲擊後帶來好運與平安',
        unlock: '預設已解鎖'
      },
      golden: {
        name: '黃金木魚',
        description: '散發財富光芒的木魚,敲擊後增加財運',
        unlock: '功德模式累計1,000次'
      },
      crystal: {
        name: '水晶木魚',
        description: '清澈透明的水晶木魚,敲擊後淨化心靈',
        unlock: '達成100次連擊'
      },
      jade: {
        name: '翡翠木魚',
        description: '象徵和平與長壽的翡翠木魚',
        unlock: '四種祈福類型各敲擊50次'
      },
      ruby: {
        name: '紅寶石木魚',
        description: '充滿熱情的紅寶石木魚,敲擊後增加活力',
        unlock: '在0.2秒內連續敲擊'
      },
      cat: {
        name: '貓咪木魚',
        description: '萌萌的貓咪造型木魚,敲擊時發出喵喵聲',
        unlock: '累計敲擊2,000次'
      },
      rainbow: {
        name: '彩虹木魚',
        description: '絢爛多彩的彩虹木魚,敲擊後帶來幸福感',
        unlock: '解鎖5種不同木魚'
      },
      cosmic: {
        name: '宇宙木魚',
        description: '蘊含無限宇宙能量的神秘木魚',
        unlock: '達到10,000次敲擊'
      }
    }
  },

  help: {
    title: '遊戲說明',
    tabs: {
      gameplay: '玩法',
      types: '類型',
      fish: '木魚',
      achievements: '成就',
      tips: '技巧'
    },
    gameplay: {
      step1: {
        title: '點擊木魚',
        description: '點擊中央的木魚進行敲擊'
      },
      step2: {
        title: '累積能量',
        description: '每次敲擊都會增加相應類型的能量'
      },
      step3: {
        title: '連續敲擊',
        description: '在2秒內連續敲擊可獲得連擊獎勵'
      },
      step4: {
        title: '自動敲擊',
        description: '開啟自動敲擊功能讓木魚自動敲打'
      }
    },
    controls: {
      title: '操作方式',
      mouse: '滑鼠點擊',
      touch: '觸控螢幕',
      keyboard: '空白鍵敲擊'
    },
    fish: {
      description: '完成特定成就可解鎖特殊木魚',
      level: {
        common: '普通',
        rare: '稀有',
        epic: '史詩',
        legendary: '傳說'
      }
    },
    achievements: {
      description: '完成各種挑戰解鎖成就獎勵',
      achievements: '個成就',
      rarity: '稀有度等級'
    },
    tips: {
      tip1: {
        title: '保持節奏',
        description: '穩定的敲擊節奏可以獲得更高連擊'
      },
      tip2: {
        title: '嘗試速度',
        description: '快速敲擊可以解鎖速度相關成就'
      },
      tip3: {
        title: '善用自動',
        description: '自動敲擊適合長時間修行'
      },
      tip4: {
        title: '收集木魚',
        description: '解鎖所有特殊木魚獲得額外獎勵'
      },
      tip6: {
        title: '切換類型',
        description: '嘗試不同類型獲得不同祝福'
      }
    },
    shortcuts: {
      title: '快捷鍵',
      space: '敲擊木魚',
      esc: '關閉彈窗'
    }
  },

  donation: {
    title: '贊助支持',
    subtitle: '您的支持是我們最大的動力',
    message: '如果您喜歡這個遊戲,歡迎贊助支持我們繼續開發更多有趣的功能',
    oneTime: '單次贊助',
    oneTimeDesc: '一次性支持',
    monthly: '每月贊助',
    monthlyDesc: '持續支持開發',
    selectAmount: '選擇金額',
    perMonth: '每月',
    donateButton: '前往支付',
    selectAmountFirst: '請選擇金額',
    thankYou: '感謝您的贊助',
    footerNote: '所有贊助將用於遊戲開發與維護',
    paymentMethod: '支付方式',
    securePayment: '安全的 Stripe 支付系統',
    supportCards: '支援信用卡、金融卡',
    instantProcess: '即時處理,安全可靠',
    poweredByStripe: 'Powered by Stripe - 安全可靠的支付系統',
    paymentPageOpened: '支付頁面已開啟,請在新視窗完成支付',
    benefits: {
      title: '贊助者福利',
      benefit1: '獲得我們的永恆感激',
      benefit2: '支持遊戲持續開發',
      benefit3: '未來可能獲得特殊獎勵'
    }
  }
};